import { Kaggle } from "@kaggle/sdk";
import { getServices } from "../../../../api/getServices";
import { EditorStatus } from "../../../types/EditorStatus";
import { normalizeAmbiguousErrorMessages } from "../../../utils/ambiguousErrors";
import { appendTerminalError } from "../../actions/terminal";
import { editorErrorOccurred, setEditorStatus } from "../editor";
type CancelKernelRunRequest = Kaggle.Sdk.Kernels.Requests.CancelKernelRunRequest;

export const cancelKernelRun = async (params: CancelKernelRunRequest) => {
  const services = getServices();

  try {
    // Set editor in queued state.
    setEditorStatus(EditorStatus.STOPPED);
    let errorText = "";
    const run = await services.kernelsClient
      .cancelKernelRun(params)
      .catch(err => {
        errorText = err;
      });
    if (errorText || !run) {
      throw new Error(errorText || "Failed to start kernel.");
    }
  } catch (error) {
    appendTerminalError(
      "An error occurred stopping the worker request.",
      error
    );
    const messages = normalizeAmbiguousErrorMessages(error);
    editorErrorOccurred(messages.join(", "));
    setEditorStatus(EditorStatus.FATAL);
    throw error;
  }
};
